import React from "react";
import { Link } from "react-router-dom";
import { translate } from "react-multi-lang";
import {
  handleMediaImgError,
  resolveMediaUrl,
} from "../../Helper/mediaUrl";
import { plainTextFromHtml } from "../../Helper/richTextHelpers";
import "./videoCastCrew.css";

/**
 * Cast & Crew tab — portrait cards (picture + name + role/bio line).
 * Per-title role column is not in BE schema yet (needs migration beyond is_kids);
 * prefer Admin description when present, else i18n "Cast".
 * Card line is plain text (HTML tags stripped); full rich text renders on person detail.
 */
function VideoCastCrew(props) {
  const { t, videoDetailsFirst } = props;
  const castCrews = (videoDetailsFirst && videoDetailsFirst.cast_crews) || [];
  const fallbackRole = t("cast_role_label") || t("cast_crews") || "Cast";

  if (!castCrews.length) {
    return (
      <div className="slider-topbottom-spacing slider-overlay video-cast-crew">
        <p className="video-cast-crew__empty">
          {t("cast_crews_empty") || "No cast & crew listed for this title."}
        </p>
      </div>
    );
  }

  const isSolo = castCrews.length === 1;
  const layoutClass = isSolo
    ? "video-cast-crew video-cast-crew--solo"
    : "video-cast-crew video-cast-crew--multi";

  return (
    <div className={`slider-topbottom-spacing slider-overlay ${layoutClass}`}>
      <ul className="video-cast-crew__grid" aria-label={t("cast_and_crew")}>
        {castCrews.map((cast) => {
          const id = cast.cast_crew_id || cast.id;
          const name = cast.name || "";
          const image = resolveMediaUrl(cast.image);
          const roleLine =
            (cast.role && String(cast.role).trim()) ||
            plainTextFromHtml(cast.description) ||
            fallbackRole;
          return (
            <li key={id || name} className="video-cast-crew__item">
              <Link
                className="video-cast-crew__card"
                to={{
                  pathname: `/cast-crew/${id}`,
                  state: {
                    cast_crew_id: id,
                    name,
                    image: cast.image,
                    description: cast.description || "",
                    role: cast.role || "",
                  },
                }}
              >
                <span className="video-cast-crew__avatar-wrap">
                  <img
                    className="video-cast-crew__avatar"
                    src={image}
                    alt=""
                    onError={handleMediaImgError}
                  />
                </span>
                <span className="video-cast-crew__name">{name}</span>
                <span className="video-cast-crew__role">{roleLine}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default translate(VideoCastCrew);
